import { render } from "./DesktopBackground.vue?vue&type=template&id=4cf1e53e&scoped=true"
import script from "./DesktopBackground.vue?vue&type=script&lang=js"
export * from "./DesktopBackground.vue?vue&type=script&lang=js"

import "./DesktopBackground.vue?vue&type=style&index=0&id=4cf1e53e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf1e53e"]])

export default __exports__